type ThenArg<T> = T extends PromiseLike<infer U> ? U : T

/**
 * Resolves an inline object of async requests in parallel
 * @param nameToPromise
 * @constructor
 */
export const NamedPromises = <
	T extends Record<string, Promise<any>>,
	TResolved extends { [P in keyof T]: ThenArg<T[P]> }
>(
	nameToPromise: T
): Promise<TResolved> => {
	const entries = Object.entries(nameToPromise)
	return Promise.all(entries.map(e => e[1])).then(results => {
		const nameToResult: TResolved = {} as any
		for (let i = 0; i < results.length; ++i) {
			const name: keyof T = entries[i][0]
			nameToResult[name] = results[i]
		}
		return nameToResult
	})
}
